module.exports = __webpack_public_path__ + "img/image_charactor.5f0b78f1.png";